<template>
  <div class="content-wrap">
    <div class="bm_left">
      <h2 class="bm_title">项目信息分类</h2>
      <div class="bm_box">
        <el-input v-model.trim="treeInfo.search" :readonly="true" placeholder="请输入">
          <template #append>
            <el-button plain icon="search" @click="warn"></el-button>
          </template>
        </el-input>
        <div class="bm_tree-box">
          <div class="bm_fenlei">
            <el-icon class="caret"><CaretRight /></el-icon>
            <p class="bm_fenlei_title" @click="nodeClick()">项目信息分类</p>
            <el-dropdown>
              <el-icon><Plus /></el-icon>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item>
                    <el-button type="default" @click="addCategory">增加</el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          <div class="bm_tree">
            <ul>
              <li class="tree_li" v-for="item in treeData" :key="item.id">
                <div :class="['tree-node', treeInfo.id == item.id ? 'active' : '']">
                  <p style="width: 100%; padding: 0 10px" @click="nodeClick(item)">{{ item.name }}</p>
                  <el-dropdown>
                    <el-icon><MoreFilled /></el-icon>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item @click="reNameCategroy(item)"><span>重命名</span></el-dropdown-item>
                        <el-dropdown-item @click="warn"><span>删除</span></el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="bm_right">
      <h3 class="bm_mc">{{ treeInfo.id ? treeInfo.selectTxt : '项目信息分类' }}</h3>
      <el-form :model="queryParams" :inline="true" label-width="140" class="search-box">
        <template v-if="!isSelected">
          <el-form-item label="项目名称">
            <el-input v-model.trim="queryParams.name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="税率/征收率">
            <el-select v-model="queryParams.rate" :empty-values="[null, undefined]">
              <el-option label="全部" value="" />
              <el-option label="0%" value="0%" />
              <el-option label="1%" value="1%" />
              <el-option label="3%" value="3%" />
              <el-option label="5%" value="5%" />
              <el-option label="6%" value="6%" />
              <el-option label="9%" value="9%" />
              <el-option label="13%" value="13%" />
            </el-select>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="queryParams.specification" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="单价">
            <el-input v-model.trim="queryParams.price" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="商品和服务税收分类编码">
            <template #label>
              <p style="width: 100%; white-space: nowrap; word-break: break-all; text-overflow: ellipsis; overflow: hidden">商品和服务税收分类编码</p>
            </template>
            <el-input v-model.trim="queryParams.code" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="商品服务简称">
            <el-input v-model.trim="queryParams.taxCategoryName" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="单位">
            <el-input v-model.trim="queryParams.unit" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="简码">
            <el-input v-model.trim="queryParams.taxCategoryCode" placeholder="请输入" />
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="项目名称">
            <el-input v-model.trim="queryParams.name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="税率/征收率">
            <el-select v-model="queryParams.rate" :empty-values="[null, undefined]">
              <el-option label="全部" value="" />
              <el-option label="0%" value="0%" />
              <el-option label="1%" value="1%" />
              <el-option label="3%" value="3%" />
              <el-option label="5%" value="5%" />
              <el-option label="6%" value="6%" />
              <el-option label="9%" value="9%" />
              <el-option label="13%" value="13%" />
            </el-select>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="queryParams.specification" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="简码">
            <el-input v-model.trim="queryParams.taxCategoryCode" placeholder="请输入" />
          </el-form-item>
        </template>
      </el-form>

      <div style="box-sizing: border-box; width: 100%; padding: 0px 20px; margin-top: 30px; display: flex; justify-content: end">
        <el-button type="default" @click="warn">重置</el-button>
        <el-button type="primary" @click="warn">查询</el-button>
      </div>

      <div style="box-sizing: border-box; width: 100%; margin-top: 30px; display: flex">
        <el-button type="primary" icon="plus" @click="addCategoryItem">添加</el-button>
        <el-button type="default" @click="warn">批量导入</el-button>
        <el-button type="default" @click="warn">税控批量导入</el-button>
        <el-dropdown style="margin-left: 10px">
          <el-button type="default">
            更多操作
            <el-icon><CaretBottom /></el-icon>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="warn"><span>批量赋码</span></el-dropdown-item>
              <el-dropdown-item @click="delBatchProject"><span>批量删除</span></el-dropdown-item>
              <el-dropdown-item @click="warn"><span>导出</span></el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div class="table-container">
        <el-table :data="tableData" :border="true"
                  ref="tableRef"
        >
          <template v-if="!isSelected">
            <el-table-column type="selection" align="center" width="55" />
          </template>
          <el-table-column label="序号" type="index" width="55" />
          <el-table-column label="项目名称" prop="name" />
          <el-table-column label="税率/征收率" prop="rate" />
          <el-table-column label="规格型号" prop="specification" />
          <el-table-column label="单价" prop="price" />
          <el-table-column label="是否含税" prop="vatSign">
            <template #default="{ row }">
              <span>{{ ['不含税', '含税'][row.vatSign] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商品和服务税收分类编码" prop="taxCategoryCode" min-width="150" />
          <el-table-column label="商品和服务税收简称" prop="taxCategoryName" min-width="150" />
          <el-table-column label="单位" prop="unit" />
          <el-table-column label="简码" prop="shortCode" />
          <template v-if="!isSelected">
            <el-table-column label="操作" fixed="right" min-width="170">
              <template #default="{ row }">
                <div>
                  <el-button type="primary" link @click="checkDetail(row)">详情</el-button>
                  <el-button type="primary" link @click="modifyCategroyItem(row)">修改</el-button>
                  <el-button type="primary" link @click="delProject(row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column label="操作" fixed="right" min-width="60">
              <template #default="{ row }">
                <div>
                  <el-button type="primary" link @click="selectRow(row)">选取</el-button>
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
    </div>

    <!--新增/修改分类  -->
    <el-dialog v-model="dialog.open" width="480" :title="dialog.title" draggable>
      <div class="dialog-body">
        <div style="margin-top: 30px" v-if="!dialog.formData.id">
          <p style="line-height: 30px; font-size: 14px; color: #333">项目信息分类节点</p>
          <p style="line-height: 30px; font-size: 14px; color: #333">项目信息分类</p>
        </div>
        <el-form :model="dialog.formData" label-position="top" style="margin-top: 30px">
          <el-form-item label="分类名称" prop="name" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
            <el-input v-model.trim="dialog.formData.name" placeholder="请输入" />
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div>
          <el-button type="default" @click="dialog.open = false">取消</el-button>
          <el-button type="primary" @click="saveCategroy">保存</el-button>
        </div>
      </template>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog v-model="showDetail" width="786" title="详情" draggable class="detail-box">
      <div style="box-sizing: border-box; width: 100%; padding: 10px; background-color: #f9fafd">
        <el-row>
          <el-col>
            <span> 项目分类: </span>
            <span>{{ `项目信息分类\\${currentRow.categoryName}` }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <span> 项目名称: </span>
            <span>{{ currentRow.name }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <span>商品和税收分类编码:</span>
            <span>{{ currentRow.taxCategoryCode }}</span>
          </el-col>
          <el-col :span="12">
            <span>商品和服务分类简称:</span>
            <span>{{ currentRow.taxCategoryName }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <span>优惠政策及简易计税:</span>
            <span>{{ ['否', '是'][currentRow.enjoyPrivileges] }}</span>
          </el-col>
          <el-col :span="12">
            <span>优惠政策及简易计税类型:</span>
            <span>{{ ['', '免税', '优惠'][currentRow.enjoyPrivilegesType] }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <span>是否选择普通零税率：</span>
            <span>{{ ['否', '是'][currentRow.applicableRate] }}</span>
          </el-col>
          <el-col :span="12">
            <span>税率/征收率：</span>
            <span>{{ currentRow.rate }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <span>是否含税：</span>
            <span>{{ ['不含税', '含税'][currentRow.vatSign] }}</span>
          </el-col>
          <el-col :span="12">
            <span>单价：</span>
            <span>{{ currentRow.price }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <span>单位：</span>
            <span>{{ currentRow.unit }}</span>
          </el-col>
          <el-col :span="12">
            <span>规格型号：</span>
            <span>{{ currentRow.specification }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <span>简码：</span>
            <span>{{ currentRow.shortCode }}</span>
          </el-col>
        </el-row>
      </div>
      <template #footer>
        <el-button type="default" @click="showDetail = false">取消</el-button>
      </template>
    </el-dialog>

    <!-- 新增/修改项目 -->
    <sp-drawer v-model="show" :row="currentRow" @refresh="getList" />
  </div>
</template>

<script setup>
import spDrawer from './spDrawer.vue';
import { ElMessageBox, ElMessage } from 'element-plus';
import useInvoiceStore from '@/store/modules/invoice';

const useInvoice = useInvoiceStore();

const props = defineProps({
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['confirm']);
//树数据
const treeInfo = reactive({
  search: undefined,
  selectTxt: '',
  id: undefined,
});
const treeData = ref([]);

//项目
const dialog = reactive({
  open: false,
  title: '',
  formData: {
    name: undefined,
    id: undefined,
  },
});

const queryParams = ref({});

const tableData = ref([]); //表格数据

//抽屉
const show = ref(false);
const currentRow = ref({});
const showDetail = ref(false);

onMounted(() => {
  getTreeData();
  getList();
});

//获取分类树
async function getTreeData() {
  const data = useInvoice.productCategory;
  treeData.value = [...toRaw(data)];
}

//获取项目数据
async function getList() {
  const data = useInvoice.productList;
  if (treeInfo?.id) {
    tableData.value = [...toRaw(data)].filter((item) => item.categoryId == treeInfo.id);
  } else {
    tableData.value = [...toRaw(data)];
  }
}

//添加种类
function addCategory() {
  dialog.open = true;
  dialog.title = '新增分类';
  Object.assign(dialog.formData, { name: undefined, id: '' });
}

//重命名种类
function reNameCategroy(data) {
  dialog.open = true;
  dialog.title = '重命名';
  Object.assign(dialog.formData, { name: data.name, id: data.id });
}

//保存项目种类
function saveCategroy() {
  if (!dialog.formData.name) return;
  if (dialog.formData.id) {
    useInvoice.updateProductCategroy(dialog.formData);
  } else {
    useInvoice.addProductCategroy(dialog.formData);
  }
  getTreeData();
  dialog.open = false;
}

//点击商品分类
function nodeClick(data) {
  if (!data) {
    treeInfo.id = undefined;
  } else {
    if (treeInfo.id !== data.id) {
      treeInfo.id = data.id;
      treeInfo.selectTxt = data.name;
    }
  }
  getList();
}

//警告功能
function warn() {
  ElMessageBox.confirm('本系统为教学系统，暂不支持此功能', '信息', {
    showCancelButton: false,
    customStyle: {
      '--el-messagebox-width': '300px',
    },
  }).catch(() => {});
}

//添加分类项目
function addCategoryItem() {
  if (!treeInfo.id) {
    ElMessage({
      message: '请选择项目信息分类',
      type: 'warning',
      customClass: 'message',
    });
    return;
  }
  show.value = true;
  currentRow.value = {};
  currentRow.value.categoryName = treeInfo.selectTxt;
  currentRow.value.categoryId = treeInfo.id;
}

//修改项目
function modifyCategroyItem(data) {
  show.value = true;
  currentRow.value = Object.assign({}, data);
}

// 删除项目
function delProject(row) {
  ElMessageBox.confirm("确认删除本条数据?", "提示")
      .then(() => {
        useInvoice.delProject([row.id])
        getList()
      })
      .catch(() => {
      })
}

const tableRef = ref()

function delBatchProject() {
  const selectRows = tableRef.value.getSelectionRows();
  if (!selectRows.length) {
    return ElMessage({
      message: "请选择数据，再批量删除",
      type: "warning",
    });
  }
  ElMessageBox.confirm("确认删除选中的数据?", "提示")
      .then(() => {
        useInvoice.delProject(selectRows.map(m => m.id))
        getList()
      })
      .catch(() => {
      })
}

//查看详情
function checkDetail(data) {
  showDetail.value = true;
  currentRow.value = Object.assign({}, data);
}

//点击选择按钮
function selectRow(row) {
  emits('confirm', row);
}
</script>

<style lang="scss" scoped>
.content-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  .bm_left {
    flex: none;
    width: 260px;
    border-right: 1px solid #eee;
    .bm_title {
      box-sizing: border-box;
      width: 100%;
      height: 60px;
      padding-left: 20px;
      line-height: 60px;
      border-bottom: 1px solid #eee;
      font-size: 18px;
      color: #333;
    }
    .bm_box {
      box-sizing: border-box;
      width: 100%;
      padding: 10px;
      .bm_tree-box {
        width: 100%;
        margin-top: 10px;
        overflow-y: auto;
        cursor: pointer;
        .bm_fenlei {
          position: relative;
          padding-left: 14px;
          line-height: 24px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .bm_fenlei_title {
            box-sizing: border-box;
            width: fit-content;
            padding: 0 10px;
            font-size: 14px;
            font-weight: 400;
          }
          .caret {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translate(-50%, -50%);
            line-height: 24px;
          }
        }
        .bm_tree {
          width: 100%;
          > ul {
            padding-left: 16px;
            .tree_li {
              padding-left: 10px;
              font-size: 12px;
              .tree-node {
                box-sizing: border-box;
                width: 100%;
                height: 28px;
                line-height: 28px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                &.active {
                  > p {
                    background-color: #ecf2fe;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .bm_right {
    flex: auto;
    box-sizing: border-box;
    padding-left: 20px;
    overflow-y: auto;
    .bm_mc {
      height: 60px;
      line-height: 60px;
      font-size: 18px;
      color: #333;
    }
    :deep(.search-box) {
      width: 100%;
      .el-form-item {
        margin-right: 0;
        .el-form-item__label {
          white-space: nowrap;
        }
        .el-form-item__content {
          > .el-input,
          .el-select {
            width: 300px;
          }
        }
      }
    }
    .table-container {
      width: 100%;
      margin-top: 10px;
    }
  }
}

:deep(.detail-box) {
  .el-dialog__body {
    .el-row .el-col {
      font-size: 14px;
      line-height: 40px;
      > span {
        &:first-child {
          color: #666;
        }
        &:last-child {
          margin-left: 5px;
          color: #333;
        }
      }
    }
  }
}
:global(.message) {
  .el-icon {
    font-size: 14px;
  }
}
</style>
